import DapDSScrollArea from './scroll-area.component'

export * from './scroll-area.component'
export default DapDSScrollArea

DapDSScrollArea.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-scroll-area': DapDSScrollArea
  }
}
